import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProductsListComponent} from '../products/products-list.component';
import {AgentCtvComponent} from './agent-ctv.component';

const routes: Routes = [
  {
    path: '',
    component: AgentCtvComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class AgentCtvRoutingModule {}
